<header>
    <h2><span i18n>Acerca de la aplicación</span></h2>
</header>
<section class="main">
    <p><span i18n>Nomber</span>: {{package_data.name}}</p>
    <p><span i18n>Versión</span>: {{package_data.version}}</p>
</section>
<footer>
    <div>
        <button mat-raised-button color="primary" matDialogClose><span i18n>Cerrar</span></button>
    </div>
    <p class="copyright">
        &copy; Petrasoft.es - 2022
    </p>
</footer>